module.exports = __webpack_public_path__ + "static/media/voicemail.2ab6b93d.svg";